export const PAYMENT_METHODS = [
  { value: "cash", label: "Cash" },
  { value: "upi", label: "UPI" },
  { value: "card", label: "Card" },
  { value: "bank_transfer", label: "Bank transfer" },
  { value: "cheque", label: "Cheque" },
  { value: "other", label: "Other" },
];

export function paymentMethodLabel(value) {
  if (!value) return "—";
  const found = PAYMENT_METHODS.find((m) => m.value === value);
  if (found) return found.label;
  if (value === "online_razorpay") return "Online (Razorpay)";
  return String(value).replace(/_/g, " ");
}
